import { poll } from 'lib/poll';
import * as operations from 'lib/graphql/queries';
import { millisecond } from 'config/constants';
import { DateRange, LatestRef } from './types';
import { toCalendarDateFormat } from 'lib/utils';
import { SelfServiceAPI } from 'apis';

export const createQuote = async (ref: LatestRef, { startDate, endDate }: DateRange) => {
  const { client, booking, setState } = ref.current;

  setState((state) => ({ ...state, startDate, endDate, stage: 'QUOTING' }));

  let amendmentId: string;
  try {
    const createResult = await SelfServiceAPI.createDateAmendment({
      bookingId: booking.id,
      checkIn: toCalendarDateFormat(startDate),
      checkOut: toCalendarDateFormat(endDate),
    });
    amendmentId = createResult.id;
  } catch {
    throw new Error('Failed creating amendment');
  }

  const quotedResult = await poll({
    requestFn: () => operations.getAmendment(client, { variables: { bookingId: booking.id, amendmentId }, fetchPolicy: 'network-only' }),
    isFinished: (result) => result.data.amendment.state !== 'QUOTING',
    timeoutMs: millisecond.MINUTE,
  });

  const { amendment } = quotedResult.data;

  setState((state) => ({ ...state, stage: amendment.state === 'QUOTED' ? 'REVIEW' : 'EDIT' }));

  return amendment;
};
